<template>
    <li
        class="select-none px-8 py-4 group transition"
        :class="this.$parent.selectedCamp === this.campSlug ? 'bg-red' : 'hover:bg-grey-lightest '"
        @click="update"
    >
        <div class="transition group-hover:translate-x-2">
            <div
                class="font-bold text-xl transition"
                :class="
                    this.$parent.selectedCamp === this.campSlug
                        ? 'text-white'
                        : 'text-grey-darkest group-hover:text-pink'
                "
            >
                {{ campName }}
            </div>
            <div
                class="font-bold text-base transition"
                :class="
                    this.$parent.selectedCamp === this.campSlug
                        ? 'text-white opacity-50'
                        : 'text-grey group-hover:text-indigo'
                "
            >
                <slot name="camp-location"></slot>
                <slot name="camp-gender"></slot>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    props: ['campName', 'campSlug', 'selectedFilter'],
    methods: {
        update() {
            if (this.$parent.processing === false) {
                this.$parent.selectedTitle = this.campName
                this.$parent.selectedCamp = this.campSlug
                this.$parent.selectedSlug = this.selectedFilter
                this.$parent.closeDoor()
                this.$parent.selectCamp()
            }
        },
    },
}
</script>
